export default __webpack_public_path__ + "static/media/hero.6a8d2d0d.jpg";